// v-horizontal-scroll.js
export default {
  beforeMount(el) {
    const handleWheel = (event) => {
      el.scrollTo({
        left: (el.scrollLeft + event.deltaY),
        behavior: 'smooth', // 使用平滑滚动
      })
      event.preventDefault()
    }

    el.addEventListener('wheel', handleWheel)

    // 在指令解绑时移除事件监听器
    el._onWheel = handleWheel
  },
  unmounted(el) {
    el.removeEventListener('wheel', el._onWheel)
  },
}
